import Image from 'next/image';

import Link from '@/components/link';
import Badge from '@/components/blog/badge';
import CardCTALink from '@/components/blog/card-cta-link';
import { truncateText } from '@/utils/resolvers';
import { SuccessStoryCardFragment } from '@/generated/graphcms-schema';

export default function CaseStudyCard({
  slug,
  coverImage,
  subTitle,
  title,
  useCases,
}: SuccessStoryCardFragment) {
  return (
    <article className="flex w-full flex-col">
      <div className="blog-image flex-shrink-0">
        {coverImage?.url && (
          <Link href={`/case-studies/${slug}`} className="blog-card-image">
            <Image
              src={coverImage.url}
              alt={coverImage.alt || ``}
              width={384}
              height={216}
              quality={100}
              layout="responsive"
              objectFit="cover"
              className="rounded bg-catskill-white"
            />
          </Link>
        )}
      </div>

      <div className="blog-card-text flex flex-1 flex-col py-4 md:px-2">
        <div className="flex-1">
          <div className="-ml-1">
            {useCases.length > 0 &&
              useCases.map((useCase, index) => {
                // If there are more than two categories, we show just the first ones
                if (index > 1) return null;

                return (
                  <Badge
                    key={useCase.slug}
                    slug={`/case-studies/use-case/${useCase.slug}`}
                    title={useCase.title}
                    variant="primary"
                    className="mr-1"
                  />
                );
              })}
          </div>

          <Link
            href={`/case-studies/${slug}`}
            className="transition-colors hover:text-cornflower"
          >
            <h3 className="blog-card-title mt-4 mb-5 text-[22px] font-bold leading-tight">
              {title}
            </h3>

            <p className="leading-normal text-light-haiti">
              {truncateText({ text: subTitle })}
            </p>
          </Link>
        </div>

        <div className="mt-6 flex justify-end">
          <CardCTALink href={`/case-studies/${slug}`} text="Learn more" />
        </div>
      </div>
    </article>
  );
}
